import { keepPreviousData } from '@tanstack/vue-query';
import type { NuxtLocationQueryValue } from '@@/shared/application';

export function useLocationFromSlugs(location: Ref<NuxtLocationQueryValue | NuxtLocationQueryValue[] | undefined>) {
  const enabled = computed(() => !!location.value);

  return useQuery({
    queryKey: [`LOCATION_FROM_SLUG`, location],
    placeholderData: keepPreviousData,
    queryFn: () => {
      return $fetch('/api/locations/from-slugs', {
        query: { location: location.value },
      });
    },
    enabled,
  });
}

export function useSearchLocations(searchTerm: Ref<string | undefined>) {
  const enabled = computed(() => !!searchTerm.value);
  return useQuery({
    queryKey: [`LOCATION_SEARCH`, searchTerm],
    placeholderData: keepPreviousData,
    queryFn: () => {
      return $fetch('/api/locations', {
        query: { search: searchTerm.value },
      });
    },
    enabled,
  });
}
